const FUNCTION_RESULTS_BLOCK_REGEX = /<function_results>([\s\S]*?)<\/function_results>/g;

/**
 * A model emulating tool-calling as text sometimes also writes out a fake `<function_results>`
 * block (role-playing the system's answer to its own call). Real results are represented as
 * native tool parts by the transport, so any such block in response text is pure hallucination —
 * strip it before the text is displayed or stored.
 */
export function stripFunctionResultsFromText(text: string): string {
    return text.replace(FUNCTION_RESULTS_BLOCK_REGEX, '').trim();
}
